import './parallax-item';



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/parallax-item/index.js